"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALL_DETAIL_RECORD_AUDIT_URL = exports.CALL_DETAIL_RECORD_TICKETS_URL = exports.CALL_DETAIL_RECORD_URL = exports.CALL_TYPE_STATUS = exports.IVR = exports.TELE_SALES = exports.PRE_QUALIFICATION = exports.COLLECTIONS_ASSISTANT = exports.KEY_ACCOUNT = exports.FROM_SUPPORT = exports.TO_SUPPORT = exports.COLLECTIONS = exports.REVIEW_STATUS_COLORS = exports.DROPPED = exports.TECHNICAL_ISSUE = exports.NETWORK_ISSUE = exports.REVIEWED = exports.NOT_REVIEWED = exports.initialFilterParams = void 0;
const constants_1 = require("../../constants/constants");
const colors_1 = __importDefault(require("../../styles/colors"));
exports.initialFilterParams = {
    id: undefined,
    file_availability: null,
    review_status: undefined,
    call_source: undefined,
    officer_first_name: undefined,
    officer_last_name: undefined,
    destination: undefined,
    external_id: undefined,
    max_duration: undefined,
    min_duration: undefined,
    max_billsec: undefined,
    min_billsec: undefined,
    billsec: undefined,
    calldate: undefined,
    disposition: undefined,
    src: undefined,
    call_type: undefined,
    officer_id: undefined,
};
exports.NOT_REVIEWED = 0;
exports.REVIEWED = 1;
exports.NETWORK_ISSUE = 2;
exports.TECHNICAL_ISSUE = 3;
exports.DROPPED = 4;
exports.REVIEW_STATUS_COLORS = {
    [exports.NOT_REVIEWED]: colors_1.default.RED,
    [exports.REVIEWED]: colors_1.default.GREEN,
    [exports.NETWORK_ISSUE]: colors_1.default.YELLOW,
    [exports.TECHNICAL_ISSUE]: colors_1.default.PURPLE,
    [exports.DROPPED]: colors_1.default.FONT_BLACK,
};
exports.COLLECTIONS = 0;
exports.TO_SUPPORT = 1;
exports.FROM_SUPPORT = 2;
exports.KEY_ACCOUNT = 3;
exports.COLLECTIONS_ASSISTANT = 4;
exports.PRE_QUALIFICATION = 5;
exports.TELE_SALES = 6;
exports.IVR = 7;
exports.CALL_TYPE_STATUS = {
    [exports.COLLECTIONS]: 'Collections',
    [exports.TO_SUPPORT]: 'To Support',
    [exports.FROM_SUPPORT]: 'From Support',
    [exports.KEY_ACCOUNT]: 'Key Account',
    [exports.COLLECTIONS_ASSISTANT]: 'Collection Assistant',
    [exports.PRE_QUALIFICATION]: 'Pre-Qualification',
    [exports.TELE_SALES]: 'Tele Sales',
    [exports.IVR]: 'IVR',
};
exports.CALL_DETAIL_RECORD_URL = `quality-assurance/call-records/${constants_1.CALL_DETAIL_RECORD_ID}/`;
exports.CALL_DETAIL_RECORD_TICKETS_URL = `quality-assurance/call-records/${constants_1.CALL_DETAIL_RECORD_ID}/tickets/`;
exports.CALL_DETAIL_RECORD_AUDIT_URL = `quality-assurance/audit/${constants_1.CALL_DETAIL_RECORD_ID}/`;
exports.default = 'quality-assurance/collections/list/';
